<li class="menu-item">
  <a class="menu-item__link" [ngClass]="{ 'menu-item__link--active': isActive }">
    <i class="menu-item__icon" [ngClass]="icon"></i>
  </a>
  <div class="menu-item__tooltip">{{ tooltip }}</div>
  <ng-content></ng-content>
</li>
